module.exports = __webpack_public_path__ + "static/media/wait-contact.2093cdf8.svg";